import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import {
    Popover,
    colors,
} from '@material-ui/core'

import { QuickLinksList } from './components'

const useStyles = makeStyles(() => ({
    root: {
        width: 250,
        maxWidth: '100%',
    },
    actions: {
        backgroundColor: colors.grey[50],
        justifyContent: 'center',
    },
}))

const QuickLinksPopover = (props) => {
    const { anchorEl, onClose, ...rest } = props

    const classes = useStyles()

    return (
        <Popover
            {...rest}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                horizontal: 'right',
                vertical: 'top'
            }}
            onClose={onClose}
        >
            <div className={classes.root}>
                <QuickLinksList closePopOver={onClose} />
            </div>
        </Popover>
    )
}

QuickLinksPopover.propTypes = {
    anchorEl: PropTypes.any,
    className: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
}

export default QuickLinksPopover
